import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { retry, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpUtilityService {
  appAPIBaseURL = environment.apiEndpoint;

  requestTimeout = environment.requestTimeout;

  constructor(private readonly http: HttpClient) {}

  get<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http
      .get<T>(`${this.appAPIBaseURL}${endpoint}`, { params })
      .pipe(timeout(this.requestTimeout), retry(2));
  }

  post<T>(endpoint: string, body: unknown): Observable<T> {
    return this.http
      .post<T>(`${this.appAPIBaseURL}${endpoint}`, body)
      .pipe(timeout(this.requestTimeout), retry(2));
  }

  postBlob(endpoint: string, body: unknown): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.appAPIBaseURL}${endpoint}`, body, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  getBlob(endpoint: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.appAPIBaseURL}${endpoint}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  put<T>(endpoint: string, body: unknown): Observable<T> {
    return this.http.put<T>(`${this.appAPIBaseURL}${endpoint}`, body);
  }

  patch<T>(endpoint: string, body: unknown): Observable<T> {
    return this.http.patch<T>(`${this.appAPIBaseURL}${endpoint}`, body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.appAPIBaseURL}${endpoint}`);
  }

  public getBy<T>(endPoint: string, data: T) {
    let path = `${this.appAPIBaseURL}/${endPoint}`;
    return this.http.request('GET', path, {
      body: data,
      observe: 'response',
    });
  }

  public getById<T>(endPoint: string, id: T) {
    let path = `${this.appAPIBaseURL}/${endPoint}/${id}`;
    return this.http.request('GET', path, {
      observe: 'response',
    });
  }

  public deleteByPayload<T>(url: string, data: any) {
    let apiPath = `${this.appAPIBaseURL}/${url}`;
    return this.http.request('DELETE', apiPath, {
      body: data,
      observe: 'response',
    });
  }
}
